import { Component, OnInit, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from 'projects/bis-shared/src/lib/utility/mask-config';
import { SelectListService } from '../../../dynamic-forms/services/form-utility/select-list.service';
import { BehaviorSubject } from 'rxjs';
import { ISelectOptionGroup } from '../../../dynamic-forms/models/select-option-group';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';

@Component({
  selector: 'app-claimant-lookup-form',
  templateUrl: './claimant-lookup-form.component.html',
  styleUrls: ['./claimant-lookup-form.component.scss'],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
     
})
export class ClaimantLookupFormComponent extends GenericLookupForm implements OnInit {
  private selectListService = inject(SelectListService);
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  formLoaded = false;
  AppUrls = AppUrls;
  FieldLabelConstants = FieldLabelConstants;

  // Search date vars
  day: number;
  month: number;
  year: number;
  dayList: BehaviorSubject<ISelectOptionGroup[]>;
  monthList: BehaviorSubject<ISelectOptionGroup[]>;
  yearList: BehaviorSubject<ISelectOptionGroup[]>;
  // end Search Date vars

  ssnMaskConfig: MaskConfig;
  clIdMaskConfig = MaskUtility.getEntityIdMask('CL');

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService.getFormGroupForModel('claimantLookup').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.form = formInfo.formGroup;

      this.dayList = this.selectListService.getNumericOptionsList('daysInAMonth', 1, 31);
      this.monthList = this.selectListService.getNumericOptionsList('monthsInAYear', 1, 12);
      this.yearList = this.selectListService.getNumericOptionsList(
        'yearsOfBirth',
        new Date().getFullYear(),
        1900,
      );

      this.formLoaded = true;
    });
  }

  onSSNChange() {
    this.ssnMaskConfig = MaskUtility.getSSNMask(this.form.value.socialSecurityNumber);
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  search() {
    this.enterKey.emit();
  }

  //
  // Search date code
  //

  dateValidator() {
    let tmpDay = this.form.value.dateOfBirthDay;
    let tmpMonth = this.form.value.dateOfBirthMonth;
    const tmpYear = this.form.value.dateOfBirthYear;
    let isDaySet: boolean;
    let isMonthSet: boolean;
    const now = new Date();

    if (!tmpDay || Number.isNaN(Number.parseInt(tmpDay.toString(), 10))) {
      isDaySet = false;
    } else {
      isDaySet = true;
    }
    if (!tmpMonth || Number.isNaN(Number.parseInt(tmpMonth.toString(), 10))) {
      isMonthSet = false;
    } else {
      isMonthSet = true;
    }

    this.form.get('dateOfBirthMonth').clearValidators();
    if (isDaySet && !isMonthSet) {
      this.form.get('dateOfBirthDay').setErrors({
        error: true,
      });
      return;
    }
    this.form.get('dateOfBirthDay').clearValidators();
    // force angular to update...
    this.form.patchValue({ dateOfBirthDay: tmpDay });

    if (!tmpYear || Number.isNaN(Number.parseInt(tmpYear.toString(), 10))) {
      if (isDaySet || isMonthSet) {
        this.form.get('dateOfBirthMonth').setErrors({
          error: true,
        });
      }
      return;
    }

    if (isMonthSet) {
      if (tmpYear === now.getFullYear()) {
        while (tmpMonth > now.getMonth() + 1) {
          tmpMonth--;
        }
        this.form.patchValue({ dateOfBirthMonth: tmpMonth });
      }

      this.selectListService.getNumericOptionsList('daysInAMonth', 1, 31);
      this.selectListService.getNumericOptionsList(
        'daysInAMonth',
        1,
        this.checkDate(tmpYear, tmpMonth - 1, 31).getDate(),
      );

      // force angular to refresh the DOM
      this.form.patchValue({ dateOfBirthMonth: tmpMonth });
    }

    if (isDaySet) {
      if (tmpYear === now.getFullYear() && tmpMonth === now.getMonth() + 1) {
        while (tmpDay > now.getDate()) {
          tmpDay--;
        }
      }
      this.form.patchValue({
        dateOfBirthDay: this.checkDate(tmpYear, tmpMonth - 1, tmpDay).getDate(),
      });
    }
  }

  getDays(dayRange) {
    const days = [];
    days.push('--');
    while (dayRange[0] <= dayRange[1]) {
      days.push(dayRange[0]++);
    }

    return days;
  }

  getMonths() {
    const monthArray = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const lst = [];
    const mLen = monthArray.length;

    lst.push({
      key: '--',
      value: '--',
    });
    for (let i = 0; i < mLen; i++) {
      lst.push({
        key: i,
        value: monthArray[i],
      });
    }

    return lst;
  }

  getYears() {
    const years = [];
    const currentYear = new Date().getFullYear();
    years.push('--');
    for (let cntr = 0; cntr < 150; cntr++) {
      years.push(currentYear - cntr);
    }
    return years;
  }

  checkDate(year: number, month: number, day: number) {
    if (
      Number.isNaN(Number.parseInt(year.toString(), 10)) ||
      Number.isNaN(Number.parseInt(month.toString(), 10)) ||
      Number.isNaN(Number.parseInt(day.toString(), 10))
    ) {
      return;
    }

    const d = new Date(year, month, day);

    if (d && d.getMonth() === month && d.getDate() === day) {
      return d;
    }

    return (() => this.changeDate(year, month, day))();
  }

  changeDate(year: number, month: number, day: number) {
    if (month > 11) {
      day = 31;
      month--;
    } else if (day > 28) {
      day--;
    }
    return this.checkDate(year, month, day);
  }
}
